(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bijon-cart-preorder-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const requests = new WeakMap();
    window.BijonCartPreorder = {
      async refresh(container, cart) {
        const target = container.querySelector('[data-bijon-cart-preorder]');
        if (!target) return;
        const previous = requests.get(target);
        if (previous) previous.abort();
        const controller = new AbortController();
        requests.set(target, controller);
        if (!cart || !cart.item_count) {
          target.hidden = true;
          target.replaceChildren();
          return;
        }
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + '?section_id=bijon-cart-preorder-notice', {
            credentials: 'same-origin', cache: 'no-store', signal: controller.signal
          });
          if (!response.ok) throw new Error('Preorder notice unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const notice = documentFragment.querySelector('[data-bijon-cart-preorder]');
          if (!notice || controller.signal.aborted) return;
          target.innerHTML = notice.innerHTML;
          target.hidden = notice.hidden;
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Unable to refresh preorder notice');
        }
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
